import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import NewsCard from '../components/NewsCard';
import { motion } from 'framer-motion';
import { Search as SearchIcon } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function Search() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q');
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (query) {
      fetchSearchResults();
    } else {
      setLoading(false);
    }
  }, [query]);

  const fetchSearchResults = async () => {
    try {
      const response = await axios.get(`${API}/search?q=${encodeURIComponent(query)}`);
      setNews(response.data);
    } catch (error) {
      console.error('Search error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen" data-testid="loading-indicator">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0055FF]"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAFAFA] dark:bg-[#0A0A0A] py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#09090B] dark:text-[#FAFAFA] mb-2">
            Suchergebnisse
          </h1>
          <p className="text-[#52525B] dark:text-[#A1A1AA] mb-8">
            {news.length} Ergebnisse für "{query}"
          </p>

          {news.length === 0 ? (
            <div className="text-center py-16" data-testid="no-results">
              <SearchIcon className="h-16 w-16 mx-auto mb-4 text-gray-400" />
              <p className="text-[#52525B] dark:text-[#A1A1AA] text-lg">Keine Ergebnisse gefunden</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="search-results-grid">
              {news.map((item, idx) => (
                <motion.div
                  key={item.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: idx * 0.05 }}
                >
                  <NewsCard news={item} />
                </motion.div>
              ))}
            </div>
          )}
        </motion.div>
      </div>
    </div>
  );
}

export default Search;
